// NOTE: scrollend event is much cleaner but it's not supported in safari yet.
//
// addEventListener(
//   'scrollend',
//   () => {
//     setSelectedSection(sectionId);
//     setCurrentScrolledSection(null);
//   },
//   { once: true },
// );
//
// Solution to check if scroll has ended.
// Credits: https://stackoverflow.com/a/4620980
export const useOnScrollEnd = (callback: () => void, delay = 500) => {
  let scrollTimer: ReturnType<typeof setTimeout> | null = null;

  const onScroll = () => {
    if (scrollTimer !== null) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(callback, delay);
  };

  addEventListener('scroll', onScroll, { once: true });
};
